/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Grid from "@techsoftware/happay-widgets/Grid"; 
import PropTypes from 'prop-types';
import { Button } from '@techsoftware/happay-widgets';
import Tabs from "@techsoftware/happay-widgets/Tabs"; 
import history from '../../utils/history';
import GenericHeader from '../../containers/GenericHeaderContainer';
import PaymentInfo from './paymentInfo';
import { CardDetailShimmer } from '../shimmering';
import {
  formatDate,
  currencyFormatter,
  dateDifference,
} from '../../helpers/genericFormator';
import { ChangeBankAccount } from './changeBankAccount';
import BillTxnList from './billTxnList';

class BalanceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openChangeBank: false,
      tab: 0,
      payInfoDialog: false,
    };
    this.statusForPenalties = ['carried_over','paid'];
  }

  componentDidMount() {
    this.props.getBillDetails({
      bill_id: this.props.match.params.balanceId
    });
    this.props.getVirtualAccDetails();
  }

  returnTab = value => {
    const billId = this.props.match.params.balanceId
    switch (value) {
      case 0: {
        return (
          <BillTxnList
            billId={billId}
            type="billTxn"
          />
        );
      }
      case 1: {
        return (
          <BillTxnList
            billId={billId}
            type="billPenalty"
          />
        );
      }
      default: {
        return <></>;
      }
    }
  };

  handleChange = (eve,index) => {
    this.setState({ tab: index });
  };

  getHeaderConfig = () => {
    const obj = {};
    obj.crossButton = {
      type: 'crossButton',
    };
    return obj;
  };

  onButtonClick = () => {
    // history.push('/balance');
    history.goBack();
  };

  openChangeBankAcc = () => {
    this.setState({
      openChangeBank: !this.state.openChangeBank,
    });
  };

  getRemainngDaysLogic(date, status, totalAmt) {
    const obj = {
      color: 'blue',
      text: '',
    };
    if(totalAmt === 0){
      return obj;
    }

    if(status === 'paid'){
      obj.color = 'green';
      obj.text = 'Cleared';
      return obj;
    }if(status === 'carried_over'){
      return obj;
    }
    const remainingDays = dateDifference(new Date(), date);
    if (remainingDays >= 0 && remainingDays <= 2) {
      obj.color = 'orange';
      switch(remainingDays){
        case 0:
          obj.text = 'Due date today'
          break;
        case 1:
          obj.text = `${remainingDays} day remaining`
          break;
        case 2:
          obj.text = `${remainingDays} days remaining`;
          break;
        default:
          break;
      }
    } else if (remainingDays > 2) {
      obj.text = `${remainingDays} days remaining`;
    } else if(totalAmt > 10){
      obj.color = 'red';
      obj.text = `${remainingDays * -1} day${
        remainingDays === -1 ? '' : 's'
      } overdue`;
    }else{
      obj.color = 'blue';
      obj.text = '';
    }
    return obj;
  }

  render() {
    const data = this.props.billDetails || {};
    const remainingDaysObj =
      (data.grace_period_end_date &&
        this.getRemainngDaysLogic(data.grace_period_end_date, data.status, data.remaining_balance)) ||
      {};
    const {payInfoDialog} = this.state;
    return (
      <Grid xs={12}>
        <GenericHeader
          title="Balance details"
          from ='invoice'
          showBreadcrumbs={false}
          headerconfig={this.getHeaderConfig()}
          onButtonClick={this.onButtonClick}
        />
        <Grid container xs={24} justify="center" alignItems="baseline" className="app-background">
          <Grid item xs={16} sm={22} md={20} lg={16} xl={16}>
            <Grid
              xs={24}
              className={`bordered-container margin-b-20 margin-t-20 padding-30 border-color-${remainingDaysObj.color}`}
            >
              {
                Object.keys(data).length === 0 ? 
                  <CardDetailShimmer/>
                  : <>
                    <Grid container xs={12} direction="row">
                      <Grid
                        item
                        xs={12}
                        direction="column"
                        className=" margin-b-30"
                      >
                        <div className="info-text regular">Net payable</div>
                        <div className="amount d-flex-imp">
                          {currencyFormatter(data.payable_amount)}
                        </div>
                        {
                          data.carryover_amount ?
                            <div>
                              <div className="info-text light">
                                {currencyFormatter(data.carryover_amount)} Carried over
                              </div>
                              <div className="info-text light">
                                {currencyFormatter(data.billed_amount)} Current billed
                              </div>
                            </div>
                            : null
                        }
                      </Grid>
                      <Grid
                        item xs={12} direction="column" alignItems="flex-start" 
                      >
                        <div className="info-text regular">Transaction period</div>
                        <div className="body dark">
                          {formatDate(data.from_date, 'DD MMM, YYYY ')}
                    - {formatDate(data.to_date, 'DD MMM, YYYY ')}
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        direction="column"
                        alignItems="flex-start"
                        className="margin-b-20"
                      >
                        <div className="info-text regular">Yet to pay</div>
                        <div className="font-24">
                          {currencyFormatter(data.remaining_balance)}
                        </div>
                        <div className="status green margin-t-10 d-flex">
                          {currencyFormatter(data.total_paid)}
                          <div className="info-text light margin-l-10">
                            Paid till now
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item xs={12} direction="column"
                        alignItems="flex-start"
                        className="margin-b-20">
                        <div className="info-text regular">Due date</div>
                        <div className="body dark">
                          {formatDate(
                            data.grace_period_end_date,
                            'DD MMM, YYYY ',
                          )}
                        </div>
                      </Grid>
                      {data.status !== 'carried_over' ?
                        <Grid item xs={12} direction="column">
                          <span className={`status font-16 ${remainingDaysObj.color} `} >
                            {remainingDaysObj.text}
                          </span>
                        </Grid>
                        : null
                      }
                    </Grid>
                    {
                      data.status === 'carried_over' || data.status === 'paid' ?
                        null :
                        <Grid xs={12} container direction="column" className='padding-t-20' alignItems="flex-start">
                          <div>
                            <Button
                              type="button" 
                              text='Pay now'
                              variant="primary"
                              size='medium'
                              // className="btn-primary btn-small"
                              onClick={event => {
                                this.setState({ payInfoDialog: true });
                                event.stopPropagation();
                              }}/>
                            <PaymentInfo
                              open={payInfoDialog}
                              accData={this.props.verAccDetails}
                              onPayInfoClose={value => {
                                this.setState({ payInfoDialog: value });
                              }}
                            />
                          </div>
                        </Grid>
                    }
                  </>
              }
            </Grid>
            <Tabs
              tabName={this.statusForPenalties.indexOf(data.status) !== -1 || remainingDaysObj.color === 'red' ? ['Transaction', 'Penalties'] : ['Transaction']}   
              onTabChange={this.handleChange}
              activeIndex={this.state.tab}
              isSmallView
              noBorder
              className= "white-bg full-width border-container-imp"
              tabStyle = {{fontSize:"14px", margin:"unset", padding:"10px 40px", minHeight:'48px'}}
            />
            {this.returnTab(this.state.tab)}
          </Grid>
        </Grid>
        <ChangeBankAccount
          open={this.state.openChangeBank}
          onClose={this.openChangeBankAcc}
          onChange={() => {}}
        />
      </Grid>
    );
  }
}

export default withRouter(BalanceDetails);


BalanceDetails.propTypes = {
  getBillDetails: PropTypes.func,
  billDetails: PropTypes.object,
  match: PropTypes.object,
  verAccDetails: PropTypes.object,
  getVirtualAccDetails: PropTypes.func,
};
